export const transfereeUrls = {
    'certificates' : '/certificates',
    'certificates_search' : '/certificates/search',
    'certificates_view' : '/certificates/view',
    'user_profile' : '/user-profile',
    // 'print_with_letterhead' : '/official/print',
    // 'print' : '/print',
}